<template>
  <div id="app">
      <router-view />
    </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
    };
  }
};
</script>
<style>
html, body, #app {
  margin: 0;
  padding: 0;
  background-color: rgb(20, 12, 31)!important;
}
.website-page-box{
  background-color: rgb(20, 12, 31);
  width: 100%;
  padding: 36px;
  box-sizing: border-box;
  height: 100%;
  color: #fff;
}
</style>
